import { MandateDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/mandates`;

export const getAllMandates = (source: CancelTokenSource): Promise<Array<MandateDto>> => {
  return axios
      .get(`${apiUri}/simple-list`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllMandatesWithDeleted = (source: CancelTokenSource): Promise<Array<MandateDto>> => {
  return axios
      .get(`${apiUri}/all`, {cancelToken: source.token})
      .then(response => response.data);
};

